export const markerSize: [number, number] = [36.2, 43]; // [width, height]

export const selectedMarkerSize = markerSize.map(size =>
  Math.round(size * 1.1)
) as [number, number]; // [width, height]

export const clusterMarkerSize = markerSize.map(size =>
  Math.round(size * 1.4)
) as [number, number]; // [width, height]
